import { Component, ReactNode } from 'react';

export default class PageLoading extends Component {
  render(): ReactNode {
    return (
      <div className="h-100 d-flex align-items-center justify-content-center mt-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
}
